import { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import {
  Card,
  Collapsible,
  CollapsibleContent,
  CollapsibleHeader,
} from "@george-labs.com/design-system"

interface ICollapsibleProps {
  title?: string /* szótárban lévő kulcs */
  titleString?: string /* szótárban nem keresendő szöveg */
  content: ReactElement | string
  isOpen?: boolean
}

const CollapsibleComponent = (props: ICollapsibleProps) => {
  const { t } = useTranslation()

  return (
    <Collapsible component={Card} isOpen={props.isOpen ? props.isOpen : false}>
      <CollapsibleHeader
        collapseLabel={t("common.close2")}
        expandLabel={t("common.open")}
      >
        <h3>{props.title ? t(props.title) : props.titleString}</h3>
      </CollapsibleHeader>
      <CollapsibleContent>{props.content}</CollapsibleContent>
    </Collapsible>
  )
}

export default CollapsibleComponent
